import axios from '@/libs/api.request'
// 导师端timesheet接口
const timesheetService = {
  // timesheet列表
  timesheetList (data) {
    return axios.request({
      url: '/ugd/timesheet/page',
      data,
      method: 'POST'
    })
  }
}

export default timesheetService
